import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Education from './components/Education';
import Research from './components/Research';
import Publications from './components/Publications';
import Projects from './components/Projects';
import Teaching from './components/Teaching';
import Labs from './components/Labs';
import Administrative from './components/Administrative';
import Awards from './components/Awards';
import Students from './components/Students';
import Contact from './components/Contact';
import Footer from './components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <About />
      <Education />
      <Research />
      <Publications />
      <Projects />
      <Teaching />
      <Labs />
      <Administrative />
      <Awards />
      <Students />
      <Contact />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;